import { useCreateNewCompanionMutation, useUpdateTravellerMutation } from '@websky/graphql';
import { useProfileUpdateService } from '../Account/hooks';
export const useSubmitPersonalDetails = (userProfile) => {
    const updatePersonalDetails = useProfileUpdateService(userProfile);
    const submit = (values) => {
        return updatePersonalDetails(Object.assign({}, values));
    };
    return {
        submit
    };
};
export const useCreateTraveller = () => {
    const [addNewCompanion] = useCreateNewCompanionMutation();
    const submit = (values) => {
        return addNewCompanion({
            variables: {
                params: {
                    middleName: values['middleName'],
                    citizenship: values['nationality'],
                    lastName: values['lastName'],
                    firstName: values['firstName'],
                    birthDate: values['birthDate'],
                    email: values['email'],
                    phone: values['phone'],
                    gender: values['gender'],
                    documents: values['documents'],
                    loyaltyCards: values['loyaltyCards']
                }
            }
        });
    };
    return {
        submit
    };
};
export const useUpdateTraveller = () => {
    const [updateTravellerProfile] = useUpdateTravellerMutation();
    const submit = (values, id) => {
        const { documents, email, gender, birthDate, loyaltyCards, phone } = values;
        const lastDocument = documents[documents.length - 1];
        return updateTravellerProfile({
            variables: {
                params: {
                    id: id,
                    newParameters: {
                        citizenship: lastDocument.citizenship,
                        lastName: lastDocument.lastName,
                        firstName: lastDocument.firstName,
                        middleName: lastDocument.middleName,
                        birthDate,
                        documents,
                        email,
                        gender,
                        loyaltyCards,
                        phone
                    }
                }
            }
        });
    };
    return {
        submit
    };
};
